import 'core-js/stable'
import 'phoenix_html'
import 'vidstack/player';
import 'vidstack/player/ui';
import 'vidstack/icons';
import Alpine from 'alpinejs'
import Clipboard from 'clipboard'
import Fuse from 'fuse.js'
import { LiveSocket } from 'phoenix_live_view'
import { Socket } from 'phoenix'

// Internal
import Map from './alpinejs/map'
import { updateTimeTags } from './hooks/TimeFormat'
import { load } from './analytics'
import Hooks, { bind } from './hooks/Hooks'
import Uploaders from './Uploaders'
import navigation from './navigation'

if (typeof window.queueMicrotask !== 'function') {
  window.queueMicrotask = function queueMicrotask(callback) {
    Promise.resolve()
      .then(callback)
      .catch((e) => setTimeout(() => {
        throw e
      }))
  }
}

window.addEventListener('clip:copy', (event) => Clipboard.copy(event.target.dataset.clipboardText))
window.addEventListener('tpn:remove', (event) => event.target.remove())
window.addEventListener('phx:remove-element', (event) => {
  const element = document.getElementById(event.detail.id)

  if (element) {
    element.remove()
  }
})

window.addEventListener('phx:push-datalayer-event', ({ detail: detail }) => {
  window.dataLayer = window.dataLayer || []
  window.dataLayer.push(detail)
})

window.addEventListener('phx:scroll-into-view', (event) => {
  let target = event.target

  if (event.detail.to) {
    target = document.getElementById(event.detail.to)
  }

  if (target) {
    target.scrollIntoView(false)
  }
})

window.addEventListener('phx:scroll-to-top', (event) => {
  const element = document.getElementById(event.detail.id)

  if (element) {
    element.scrollTo(0, 0)
  } else {
    window.scrollTo(0, 0)
  }
})

window.addEventListener('phx:scroll-to-bottom', (event) => {
  const element = document.getElementById(event.detail.dispatcher.id)

  if (element) {
    requestAnimationFrame(() => {
      element.scrollTop = element.scrollHeight;
    });
  }
})

window.addEventListener('phx:clear-textarea', (event) => {
  const element = document.getElementById(event.detail.id);

  if (element && element.value.trim() !== '') {
    element.value = '';
  }
});

window.addEventListener('phx:chat-scroll-near-bottom', (event) => {
  const target = event.detail.dispatcher;
  const scrollableContainer = target.closest('.overflow-y-auto');

  if (scrollableContainer) {
    const THRESHOLD = 250;
    const scrollPosition = scrollableContainer.scrollTop + scrollableContainer.clientHeight;
    const scrollHeight = scrollableContainer.scrollHeight;

    if (scrollHeight - scrollPosition <= THRESHOLD) {
      target.scrollIntoView(false);
    }
  }
});

window.addEventListener('phx:scroll-near-bottom', (event) => {
  const target = event.target
  const parent = target.parentNode

  if ((parent.scrollHeight - (parent.scrollTop + parent.clientHeight + target.clientHeight + 10)) <= 0) {
    event.target.scrollIntoView(false)
  }
})

window.addEventListener('phx:show-ping', (e) => {
  document.querySelectorAll('[data-show-ping]').forEach((element) => {
    const parentElement = document.querySelector('#sitewide-chat');
    const childElement = document.activeElement

    const isActive = (parentElement.contains(childElement));

    if (element.id === e.detail.id && (!isActive || e.detail.inactive_unread_messages)) {
      liveSocket.execJS(element, element.getAttribute('data-show-ping'))
    }
  })
})

window.addEventListener('phx:hide-ping', (e) => {
  document.querySelectorAll('[data-hide-ping]').forEach((element) => {
    if (element.id === e.detail.id) {
      liveSocket.execJS(element, element.getAttribute('data-hide-ping'))
    }
  })
})

function alpinejs() {
  window.Alpine = Alpine

  Alpine.data('map', () => Map.create())

  Alpine.data('modal', () => ({
    init() {
      this.$el.focus()
    },
  }))

  Alpine.data('merge', (...dataSets) => {
    return dataSets.reduce((data, dataSet) => {
      return { ...data, ...dataSet }
    }, {})
  })

  Alpine.start()
}

function liveview() {
  const csrfToken = document.querySelector('meta[name="csrf-token"]')
  const liveSocket = new LiveSocket('/live', Socket, {
    dom: {
      // eslint-disable-next-line complexity
      onBeforeElUpdated(from, toNode) {
        if (from._x_dataStack) {
          window.Alpine.clone(from, toNode)
        }

        // fix for prepend optimizations that remove alpine init
        if (from.getAttribute('phx-update') && from.getAttribute('phx-update') !== 'ignore') {
          Alpine.initTree(toNode)
        }

        // fix for syncing assigns
        if (from.getAttribute('x-data-sync') === 'true') {
          Alpine.initTree(toNode)
        }
      },
    },
    longPollFallbackMs: 2500,
    params: {
      // eslint-disable-next-line camelcase
      _csrf_token: csrfToken && csrfToken.getAttribute('content'),
    },
    metadata: {
      keydown: (event, _element) => ({ key: event.key, metaKey: event.metaKey, repeat: event.repeat }),
    },
    hooks: Hooks,
    uploaders: Uploaders,
  })

  bind()

  liveSocket.connect()

  window.liveSocket = liveSocket
}

window.addEventListener('phx:live_reload:attached', ({ detail: reloader }) => {
  reloader.enableServerLogs()
})

document.addEventListener('DOMContentLoaded', () => {
  load()
  updateTimeTags()
  navigation.load()

  alpinejs()
  liveview()
})

document.addEventListener('phx:update', () => {
  updateTimeTags()
})
